import Vue from "vue"
import VueI18n from "vue-i18n"
import init from "@/pages/success-page/init"
import getLocale from "@/utils/locale"

Vue.use(VueI18n)

export default () => {
  const container = document.querySelector("#success_page")

  if (!container) {
    return
  }

  const app = init(Vue, getLocale())
  app.$mount(container)
}
